var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2l5zFrEIIbvjUm{background-color:hsla(0,0%,100%,.3);height:32px;width:32px;border-radius:3px}.HXsjTkp51Q46Cf{background-image:url(" + escape(require("resources/images/header-logo-2x.png")) + ");background-position:100% 0;background-repeat:no-repeat;background-size:80px 30px;cursor:pointer;display:inline-block;height:30px;width:58px;margin-left:22px}._3HThi-OMdmkcyL{background-image:url(" + escape(require("resources/images/header-loading-logo.gif")) + ");background-size:18px 18px;display:inline-block;height:18px;right:59px;position:absolute;top:6px;width:18px}", ""]);

// exports
exports.locals = {
	"buttonSkeleton": "_2l5zFrEIIbvjUm",
	"defaultLogo": "HXsjTkp51Q46Cf",
	"loadingLogo": "_3HThi-OMdmkcyL"
};